// Theme Scripts
(function() {
  'use strict';

  // Utility Functions
  const Utils = {
    ready: function(fn) {
      if (document.readyState !== 'loading') {
        fn();
      } else {
        document.addEventListener('DOMContentLoaded', fn);
      }
    },

    on: function(selector, event, handler) {
      document.querySelectorAll(selector).forEach(el => {
        el.addEventListener(event, handler);
      });
    },

    addClass: function(selector, className) {
      document.querySelectorAll(selector).forEach(el => {
        el.classList.add(className);
      });
    },

    removeClass: function(selector, className) {
      document.querySelectorAll(selector).forEach(el => {
        el.classList.remove(className);
      });
    },

    toggleClass: function(selector, className) {
      document.querySelectorAll(selector).forEach(el => {
        el.classList.toggle(className);
      });
    }
  };

  // Navigation
  const Navigation = {
    init: function() {
      const links = document.querySelectorAll('.header__nav-link');
      const currentPath = window.location.pathname;

      links.forEach(link => {
        const href = link.getAttribute('href');
        if (currentPath === href || (href === '/' && currentPath === '/')) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
    }
  };

  // Smooth Scroll
  const SmoothScroll = {
    init: function() {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          const target = document.querySelector(anchor.getAttribute('href'));
          if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
          }
        });
      });
    }
  };

  // Intersection Observer for fade-in animations
  const FadeInObserver = {
    init: function() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }
        });
      }, {
        threshold: 0.1
      });

      document.querySelectorAll('.service-card').forEach(card => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(20px)';
        card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(card);
      });
    }
  };

  // Initialize all modules
  Utils.ready(function() {
    Navigation.init();
    SmoothScroll.init();
    FadeInObserver.init();
  });

  // Expose Utils to window for manual use
  window.ThemeUtils = Utils;
})();
